(() => {

  /* ==========================================================
     KACE WEAR — REVIEWS PROGRESSIVE LOADING

     Página: /pages/reviews

     - Mantém os primeiros 25 reviews nativos do Judge.me.
     - Busca páginas seguintes somente após clique.
     - Normaliza data e imagem dos cards carregados pela API.
     - Preserva a estrutura .jdgm-rev original.
     - Implementa expansão própria para "Avaliação Completa"
       nos cards carregados pela API.
     ========================================================== */

  if (window.location.pathname !== '/pages/reviews') {
    return;
  }


  const PUBLIC_API_KEY =
    'sLsREIsSaxxVJDIL5qpCCEJeufw';


  const SHOP_DOMAIN =
    'k-a-ce.myshopify.com';


  const API_ENDPOINT =
    'https://api.judge.me/api/v1/widgets/all_reviews_page';


  const WIDGET_SELECTOR =
    '.jdgm-all-reviews-widget';


  const TRACK_SELECTOR =
    '.jdgm-glider-track';


  const REVIEW_SELECTOR =
    '.jdgm-rev';


  const REVIEWS_PER_PAGE = 25;


  let currentPage = 1;
  let isLoading = false;



  /* ==========================================================
     IDENTIFICAÇÃO
     ========================================================== */

  function getReviewId(review) {
    return review.getAttribute(
      'data-review-id'
    );
  }



  /* ==========================================================
     TIPO DE AVALIAÇÃO
     ========================================================== */

  function getCurrentReviewType(widget) {
    const activeTab =
      widget.querySelector(
        '.jdgm-all-reviews__tab.jdgm--active, ' +
        '.jdgm-all-reviews__tab[aria-selected="true"]'
      );


    if (activeTab) {
      const text =
        activeTab.textContent
          .trim()
          .toLowerCase();


      if (
        text.includes('loja') ||
        text.includes('shop')
      ) {
        return 'shop-reviews';
      }
    }


    return 'product-reviews';
  }



  /* ==========================================================
     DATA
     ========================================================== */

  function prepareReviewDate(review) {
    const timestamp =
      review.querySelector(
        '.jdgm-rev__timestamp'
      );


    if (!timestamp) {
      return;
    }


    const rawDate =
      timestamp.getAttribute(
        'data-content'
      );


    /*
      Se o Judge.me já entregou o texto,
      apenas removemos eventual spinner.
    */

    if (timestamp.textContent.trim()) {
      timestamp.classList.remove(
        'jdgm-spinner'
      );

      return;
    }


    if (!rawDate) {
      timestamp.classList.remove(
        'jdgm-spinner'
      );

      return;
    }


    /*
      data-content:
      2026-05-24 06:04:29 UTC

      Resultado:
      24/05/26
    */

    const match =
      rawDate.match(
        /^(\d{4})-(\d{2})-(\d{2})/
      );


    if (match) {
      const year =
        match[1].slice(-2);

      const month =
        match[2];

      const day =
        match[3];


      timestamp.textContent =
        `${day}/${month}/${year}`;
    }


    timestamp.classList.remove(
      'jdgm-spinner'
    );
  }



  /* ==========================================================
     IMAGEM DO PRODUTO
     ========================================================== */

  function prepareReviewImage(review) {
    const pics =
      review.querySelector(
        '.jdgm-rev__pics'
      );


    const image =
      review.querySelector(
        '.jdgm-rev__pic-img'
      );


    const pictureLink =
      review.querySelector(
        '.jdgm-rev__pic-link'
      );


    /*
      Reviews sem imagem não precisam
      de nenhum tratamento.
    */

    if (
      !pics ||
      !image ||
      !pictureLink
    ) {
      return;
    }


    /*
      A API do Judge.me fornece a URL
      correta em src e/ou data-src.
    */

    const source =
      image.getAttribute('src') ||
      image.getAttribute('data-src');


    if (!source) {
      return;
    }


    /*
      Garante que a imagem possua src.
    */

    if (!image.getAttribute('src')) {
      image.setAttribute(
        'src',
        source
      );
    }


    /*
      CORREÇÃO PRINCIPAL:

      Nos cards carregados pela API,
      o Judge.me mantém .jdgm-rev__pics
      com display:none porque esses cards
      não passam pela inicialização nativa.

      O container só é exibido quando
      realmente existe uma imagem.
    */

    pics.style.setProperty(
      'display',
      'block',
      'important'
    );


    pics.style.setProperty(
      'position',
      'absolute',
      'important'
    );


    pics.style.setProperty(
      'left',
      '20px',
      'important'
    );


    pics.style.setProperty(
      'bottom',
      '44px',
      'important'
    );


    pics.style.setProperty(
      'margin',
      '0',
      'important'
    );


    /*
      Reproduz as dimensões observadas
      nos cards inicializados nativamente.
    */

    pictureLink.style.setProperty(
      'width',
      '48px',
      'important'
    );


    pictureLink.style.setProperty(
      'height',
      '48px',
      'important'
    );


    image.style.setProperty(
      'width',
      '100%',
      'important'
    );


    image.style.setProperty(
      'height',
      '100%',
      'important'
    );


    /*
      Remove eventuais estados de loading
      presentes no HTML recebido pela API.
    */

    pics.classList.remove(
      'jdgm--loading'
    );


    pictureLink.classList.remove(
      'jdgm--loading'
    );


    image.classList.remove(
      'jdgm--loading'
    );
  }



  /* ==========================================================
     AVALIAÇÃO COMPLETA — CARDS DA API
     ========================================================== */

  /* ==========================================================
   AVALIAÇÃO COMPLETA — MODAL DOS CARDS DA API
   ========================================================== */

function getKaceReviewModal() {
  let modal =
    document.querySelector(
      '.kace-review-modal'
    );

  if (modal) {
    return modal;
  }

  modal =
    document.createElement('div');

  modal.className =
    'kace-review-modal';

  modal.setAttribute(
    'aria-hidden',
    'true'
  );

  modal.innerHTML = `
    <div
      class="kace-review-modal__backdrop"
      data-kace-modal-close
    ></div>

    <div
      class="kace-review-modal__dialog"
      role="dialog"
      aria-modal="true"
      aria-label="Avaliação Completa"
    >
      <button
        type="button"
        class="kace-review-modal__close"
        aria-label="Fechar avaliação"
        data-kace-modal-close
      >
        ×
      </button>

      <div
        class="kace-review-modal__content"
      ></div>
    </div>
  `;

  document.body.appendChild(
    modal
  );

  const closeModal = () => {
    modal.classList.remove(
      'kace-review-modal--open'
    );

    modal.setAttribute(
      'aria-hidden',
      'true'
    );

    document.documentElement
      .classList.remove(
        'kace-review-modal-open'
      );

    document.body
      .classList.remove(
        'kace-review-modal-open'
      );

    const content =
      modal.querySelector(
        '.kace-review-modal__content'
      );

    if (content) {
      content.innerHTML = '';
    }
  };

  modal
    .querySelectorAll(
      '[data-kace-modal-close]'
    )
    .forEach(element => {
      element.addEventListener(
        'click',
        closeModal
      );
    });

  document.addEventListener(
    'keydown',
    event => {
      if (
        event.key === 'Escape' &&
        modal.classList.contains(
          'kace-review-modal--open'
        )
      ) {
        closeModal();
      }
    }
  );

  modal.kaceCloseModal =
    closeModal;

  return modal;
}


function openKaceReviewModal(review) {
  const modal =
    getKaceReviewModal();

  const content =
    modal.querySelector(
      '.kace-review-modal__content'
    );

  if (!content) {
    return;
  }

  /*
    Clonamos o próprio card recebido
    pela API para preservar os dados
    originais entregues pelo Judge.me.
  */

  const clone =
    review.cloneNode(true);

  /*
    O botão "Avaliação Completa"
    pertence ao grid e não deve
    aparecer dentro do modal.
  */

  clone
    .querySelectorAll(
      '.jdgm-rev__read-full, ' +
      '.kace-review-read-full'
    )
    .forEach(element => {
      element.remove();
    });

  /*
    Removemos os estados usados
    exclusivamente pelo grid.
  */

  clone.classList.remove(
    'jdgm-glider-slide'
  );

  clone.classList.remove(
    'kace-review-expanded'
  );

  clone.removeAttribute(
    'style'
  );

  /*
    No modal o comentário deve ser
    exibido integralmente.
  */

  const body =
    clone.querySelector(
      '.jdgm-rev__body'
    );

  if (body) {
    body.style.setProperty(
      'height',
      'auto',
      'important'
    );

    body.style.setProperty(
      'max-height',
      'none',
      'important'
    );

    body.style.setProperty(
      'overflow',
      'visible',
      'important'
    );

    body.style.setProperty(
      'white-space',
      'normal',
      'important'
    );

    body.style.setProperty(
      'text-overflow',
      'clip',
      'important'
    );
  }

  const reviewContent =
    clone.querySelector(
      '.jdgm-rev__content'
    );

  if (reviewContent) {
    reviewContent.style.setProperty(
      'height',
      'auto',
      'important'
    );

    reviewContent.style.setProperty(
      'max-height',
      'none',
      'important'
    );

    reviewContent.style.setProperty(
      'overflow',
      'visible',
      'important'
    );
  }

  /*
    As imagens dos cards da API possuem
    posicionamento específico para o grid.

    Dentro do modal esse posicionamento
    precisa ser neutralizado.
  */

  const pics =
    clone.querySelector(
      '.jdgm-rev__pics'
    );

  if (pics) {
    pics.style.removeProperty(
      'position'
    );

    pics.style.removeProperty(
      'left'
    );

    pics.style.removeProperty(
      'bottom'
    );

    pics.style.removeProperty(
      'margin'
    );

    pics.style.setProperty(
      'display',
      'block',
      'important'
    );
  }

    prepareReviewTranslation(
    clone
  );

  content.innerHTML = '';

  content.appendChild(
    clone
  );

  modal.classList.add(
    'kace-review-modal--open'
  );

  modal.setAttribute(
    'aria-hidden',
    'false'
  );

  document.documentElement
    .classList.add(
      'kace-review-modal-open'
    );

  document.body
    .classList.add(
      'kace-review-modal-open'
    );

  const closeButton =
    modal.querySelector(
      '.kace-review-modal__close'
    );

  if (closeButton) {
    closeButton.focus();
  }
}


function prepareReadFull(review) {
  if (
    review.dataset.kaceReadFull ===
    'true'
  ) {
    return;
  }

  const body =
    review.querySelector(
      '.jdgm-rev__body'
    );

  if (!body) {
    return;
  }

  let readFull =
    review.querySelector(
      '.jdgm-rev__read-full'
    );

  /*
    Os cards vindos da API normalmente
    não recebem o controle criado pelo
    JavaScript nativo do Judge.me.
  */

  if (!readFull) {
    readFull =
      document.createElement(
        'button'
      );

    readFull.type =
      'button';

    readFull.className =
      'jdgm-rev__read-full ' +
      'kace-review-read-full';

    readFull.textContent =
      'Avaliação Completa';

    review.appendChild(
      readFull
    );
  }

  /*
    Caso a API entregue um <a>,
    neutralizamos sua navegação.

    O clique será controlado pelo
    nosso modal.
  */

  if (
    readFull.tagName === 'A'
  ) {
    readFull.removeAttribute(
      'href'
    );

    readFull.setAttribute(
      'role',
      'button'
    );
  }

  readFull.setAttribute(
    'aria-haspopup',
    'dialog'
  );

  readFull.addEventListener(
    'click',
    event => {
      event.preventDefault();
      event.stopPropagation();

      openKaceReviewModal(
        review
      );
    }
  );

  review.dataset.kaceReadFull =
    'true';
}


/* ==========================================================
   TRADUÇÃO — CARDS DA API
   ========================================================== */

function prepareReviewTranslation(review) {

  /*
    Evita criar o controle mais de uma vez
    caso o card seja processado novamente.
  */

  if (
    review.querySelector(
      '.jdgm-translate-container'
    )
  ) {
    return;
  }


  /*
    Dados utilizados pelo próprio Judge.me
    para identificar a avaliação e o idioma
    original.
  */

  const reviewId =
    review.getAttribute(
      'data-review-id'
    );

  const reviewLanguage =
    review.getAttribute(
      'data-review-language'
    );


  /*
    Sem essas informações não conseguimos
    entregar ao Judge.me um controle válido.
  */

  if (
    !reviewId ||
    !reviewLanguage
  ) {
    return;
  }


  /*
    Cria a mesma estrutura utilizada
    nativamente pelo Judge.me:

    .jdgm-translate-container
      .jdgm-translate-icon
      .jdgm-translate-button
  */

  const container =
    document.createElement('div');

  container.className =
    'jdgm-translate-container';


  const icon =
    document.createElement('span');

  icon.className =
    'jdgm-translate-icon';


  const button =
    document.createElement('button');

  button.className =
    'jdgm-translate-button';

  button.type =
    'button';


  /*
    Mantém os mesmos data attributes
    utilizados pelo controle nativo.

    O próprio Judge.me passa a controlar
    a tradução depois do clique.
  */

  button.dataset.reviewId =
    reviewId;

  button.dataset.reviewLanguage =
    reviewLanguage;


  /*
    Para avaliações cujo idioma original
    é português, usamos o texto definido
    para a página da Kace Wear.

    Para outros idiomas mantemos um texto
    neutro, deixando o Judge.me assumir
    o estado seguinte após o clique.
  */

  if (
    reviewLanguage
      .toLowerCase()
      .startsWith('pt')
  ) {
    button.textContent =
      'Mostrar original (português)';
  } else {
    button.textContent =
      'Mostrar original';
  }


  container.append(
    icon,
    button
  );


  /*
    O controle é inserido dentro do card.

    Quando o card for clonado para o modal,
    essa mesma estrutura será levada junto,
    exatamente como ocorre com o restante
    do conteúdo da avaliação.
  */

  review.appendChild(
    container
  );
}




  /* ==========================================================
     PREPARAÇÃO DO CARD DA API
     ========================================================== */

function prepareApiReview(review) {

  /*
    Não adicionamos:
    - jdgm-review-card
    - kace-api-review
    - jdgm--done-setup

    Preservamos a estrutura original
    .jdgm-rev fornecida pelo Judge.me.
  */

  review.classList.remove(
    'kace-review-hidden'
  );
  

    review.classList.add(
    'kace-api-layout'
  );


  prepareReviewDate(review);


  prepareReviewImage(review);


  prepareReadFull(review);


}


  /* ==========================================================
     API
     ========================================================== */

  async function fetchReviews(
    page,
    reviewType
  ) {
    const url =
      new URL(API_ENDPOINT);


    url.searchParams.set(
      'api_token',
      PUBLIC_API_KEY
    );


    url.searchParams.set(
      'shop_domain',
      SHOP_DOMAIN
    );


    url.searchParams.set(
      'page',
      String(page)
    );


    url.searchParams.set(
      'review_type',
      reviewType
    );


    const response =
      await fetch(
        url.toString()
      );


    if (!response.ok) {
      throw new Error(
        `Judge.me API: HTTP ${response.status}`
      );
    }


    const data =
      await response.json();


    const temporaryContainer =
      document.createElement('div');


    temporaryContainer.innerHTML =
      data.all_reviews || '';


    return Array.from(
      temporaryContainer.querySelectorAll(
        REVIEW_SELECTOR
      )
    );
  }



  /* ==========================================================
     BOTÃO CARREGAR MAIS
     ========================================================== */

  function createLoadMoreButton() {
    const button =
      document.createElement(
        'button'
      );


    button.type =
      'button';


    button.className =
      'kace-reviews-load-more';


    button.textContent =
      'Carregar mais avaliações';


    return button;
  }



  /* ==========================================================
     TEXTO ESCREVER AVALIAÇÃO
     ========================================================== */

  function updateWriteReviewText(
    widget
  ) {
    const writeReviewButton =
      widget.querySelector(
        '.jdgm-write-rev-link'
      );


    if (!writeReviewButton) {
      return;
    }


    if (
      writeReviewButton
        .textContent
        .trim() !==
      'ESCREVER AVALIAÇÃO'
    ) {
      writeReviewButton.textContent =
        'ESCREVER AVALIAÇÃO';
    }
  }



  /* ==========================================================
     FOOTER KACE
     ========================================================== */

  function createKaceFooter(widget) {

    /*
      Se já existe, não recriamos.
    */

    if (
      widget.querySelector(
        '.kace-reviews-footer'
      )
    ) {
      return;
    }


    const summaryInner =
      widget.querySelector(
        '.jdgm-rev-widg__summary-inner'
      );


    const actionsWrapper =
      widget.querySelector(
        '.jdgm-widget-actions-wrapper'
      );


    if (
      !summaryInner ||
      !actionsWrapper
    ) {
      return;
    }


    const footer =
      document.createElement('div');


    footer.className =
      'kace-reviews-footer';


    const summary =
      document.createElement('div');


    summary.className =
      'kace-reviews-footer__summary';


    const divider =
      document.createElement('div');


    divider.className =
      'kace-reviews-footer__divider';


    divider.setAttribute(
      'aria-hidden',
      'true'
    );


    const action =
      document.createElement('div');


    action.className =
      'kace-reviews-footer__action';


    summary.appendChild(
      summaryInner
    );


    action.appendChild(
      actionsWrapper
    );


    footer.appendChild(
      summary
    );


    footer.appendChild(
      divider
    );


    footer.appendChild(
      action
    );


    const header =
      widget.querySelector(
        '.jdgm-all-reviews__header'
      );


    if (header) {
      header.insertAdjacentElement(
        'afterend',
        footer
      );
    } else {
      widget.appendChild(
        footer
      );
    }
  }



  /* ==========================================================
     INICIALIZAÇÃO
     ========================================================== */

  function initializeReviews(widget) {

    /*
      Essas duas operações podem precisar
      acontecer depois da renderização
      assíncrona do Judge.me.
    */

    createKaceFooter(widget);


    updateWriteReviewText(widget);


    /*
      A paginação deve ser inicializada
      apenas uma vez.
    */

    if (
      widget.dataset
        .kaceProgressiveLoading ===
      'true'
    ) {
      return;
    }


    const track =
      widget.querySelector(
        TRACK_SELECTOR
      );


    if (!track) {
      return;
    }


    const carousel =
      track.closest(
        '.jdgm-row-carousel'
      );


    if (!carousel) {
      return;
    }


    widget.dataset
      .kaceProgressiveLoading =
      'true';


    /*
      Remove botões de versões anteriores.
    */

    widget
      .querySelectorAll(
        '.kace-reviews-load-more'
      )
      .forEach(
        button =>
          button.remove()
      );


    /*
      Oculta a paginação nativa.
    */

    widget
      .querySelectorAll(
        '.jdgm-row-readmore'
      )
      .forEach(element => {
        element.style.display =
          'none';
      });


    const button =
      createLoadMoreButton();


    carousel.insertAdjacentElement(
      'afterend',
      button
    );


    /* ========================================================
       CLIQUE
       ======================================================== */

    button.addEventListener(
      'click',
      async () => {

        if (isLoading) {
          return;
        }


        isLoading = true;


        const nextPage =
          currentPage + 1;


        button.disabled =
          true;


        button.textContent =
          'Carregando...';


        try {
          const reviewType =
            getCurrentReviewType(
              widget
            );


          const reviews =
            await fetchReviews(
              nextPage,
              reviewType
            );


          /*
            IDs que já estão no grid.
          */

          const existingIds =
            new Set(
              Array.from(
                track.querySelectorAll(
                  REVIEW_SELECTOR
                )
              )
                .map(getReviewId)
                .filter(Boolean)
            );


          /*
            Remove eventuais duplicados.
          */

          const newReviews =
            reviews.filter(
              review => {
                const id =
                  getReviewId(
                    review
                  );


                return (
                  !id ||
                  !existingIds.has(id)
                );
              }
            );


          /*
            Nenhum card novo = fim.
          */

          if (
            newReviews.length === 0
          ) {
            button.hidden =
              true;

            return;
          }


          const fragment =
            document
              .createDocumentFragment();


          /*
            Prepara os cards recebidos
            pela API antes da inserção.
          */

          newReviews.forEach(
            review => {

              prepareApiReview(
                review
              );


              fragment.appendChild(
                review
              );
            }
          );


          track.appendChild(
            fragment
          );


          currentPage =
            nextPage;


          /*
            Menos de 25 = última página.
          */

          if (
            reviews.length <
            REVIEWS_PER_PAGE
          ) {
            button.hidden =
              true;
          }


        } catch (error) {
          console.error(
            '[Kace Reviews]',
            error
          );


          button.textContent =
            'Tentar novamente';


          return;


        } finally {
          isLoading =
            false;


          button.disabled =
            false;


          if (!button.hidden) {
            button.textContent =
              'Carregar mais avaliações';
          }
        }
      }
    );
  }



  /* ==========================================================
     BUSCA PELO WIDGET
     ========================================================== */

  function initialize() {
    document
      .querySelectorAll(
        WIDGET_SELECTOR
      )
      .forEach(
        initializeReviews
      );
  }



  /* ==========================================================
     JUDGE.ME É ASSÍNCRONO
     ========================================================== */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }


  const observer =
    new MutationObserver(() => {
      initialize();
    });


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();